import { connect } from 'react-redux'
import SystemPreview from './SystemPreview'
import { showSettingsModal } from '../../dataStore/actions/ui/uiActions'
import { State } from '../../dataStore/reducers/reducerType'
import { toggleAudio, toggleVideo, setAudioSource } from '../../dataStore/actions/tracks/trackActions'
import selectPresenterMuted from '../../dataStore/selectors/selectPresenterMuted'
import selectPresenterHidden from '../../dataStore/selectors/selectPresenterHidden'
import { SystemPreviewProps } from './types'
import selectIsLocalParticipantDialedIn from '../../dataStore/selectors/selectIsLocalParticipantDialedIn'
import selectPresenterBackground from '../../dataStore/selectors/selectPresenterBackground'
import selectLocalParticipant from '../../dataStore/selectors/selectLocalParticipant'


const mapStateToProps = (state: State): Omit<SystemPreviewProps, 'onClickAudio' | 'onClickVideo' | 'showSettingsModal' | 'setAudioSource'> => {

  const getPresenterHidden = selectPresenterHidden()
  const getPresenterMuted = selectPresenterMuted()
  const getPresenterBackground = selectPresenterBackground()


  return {
    audioSource: state.tracks.audioSource,
    BTID: state.user.BTID || '',
    selectedVideoDeviceId: state.tracks.selectedVideoDeviceID,
    selectedAudioDeviceId: state.tracks.selectedAudioDeviceID,
    isDialInConnected: selectIsLocalParticipantDialedIn(state),
    isHidden: getPresenterHidden(state, { presenter: { BTID: state.user.BTID }, ignoreRoom: true }),
    isMuted: getPresenterMuted(state, { presenter: { BTID: state.user.BTID }, ignoreRoom: true }),
    background: getPresenterBackground(state),
    localParticipant: selectLocalParticipant(state)
  }

}
const mapDispatchToProps = dispatch => ({
  onClickAudio: (BTID) => dispatch(toggleAudio(BTID)),
  onClickVideo: (BTID) => dispatch(toggleVideo(BTID)),
  showSettingsModal: () => dispatch(showSettingsModal()),
  setAudioSource: audioSource => dispatch(setAudioSource(audioSource))
})

export default connect(mapStateToProps, mapDispatchToProps)(SystemPreview)
